import styles from './UptimeSplash.module.scss';

import React from 'react';
import { Container } from 'reactstrap';
import ButtonLink from 'src/components/ButtonLink';
import {
  ScrollOverPack,
  TweenOne,
  FadeUp,
  FadeRight
} from 'src/components/Animations';

export default (props) => (
  <ScrollOverPack component={Container} styleName='uptime-splash'>
      <TweenOne key='square' styleName='square-container' {...FadeRight}>
          <div styleName='square-content'>
              <div styleName='heading'>Data uptime guarantee</div>
              <div styleName='number'>99.99%</div>
              <div styleName='faded-text'>Depending on plan purchase</div>
          </div>
      </TweenOne>
      <TweenOne key='text' styleName='text-container' {...FadeUp}>
          <div>
              <div className='h2'>
                  Your team is always on
              </div>
              <div className='h2 text-blue'>
                  So are we.
              </div>
              <div styleName='message'>
                  Our high-availability services are always on. You can count on
                  Galleon to keep your data live, even when your carrier portals go
                  down.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </TweenOne>
  </ScrollOverPack>
);



// WEBPACK FOOTER //
// ./src/components/UptimeSplash.js